import React, { useEffect, useState } from "react";

import SettingsTutorial from "../SettingsTutorial";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";
import ImagePortfolio from "../../../../assets/img/service/portforio.webp";

import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import {
  getLinkedPages,
  getOwnDBEntries,
  getUserDBEntries,
  updateOwnDBEntry,
  requestDBEntryApproval,
} from "../../../../redux/reducers/user";

import { PageVisibility } from "../../../../utils/PageVisibility";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";

const DatabaseEntrySettingsContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  // TODO page relationshipsからIDを指定してdispatchする処理を追加
  const dbEntries = useAppSelector(getUserDBEntries);
  const linked_pages = useAppSelector(getLinkedPages);
  const auth_token = useAppSelector(getAuthToken);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id?: string) => {
    if (auth_token && id) {
      setIsLoading(true);

      const promise = dispatch(
        updateOwnDBEntry({
          auth_token,
          id: id,
          update: {
            sonic_status: PageVisibility.NotPubliclyVisible,
          },
        })
      );
      promise.finally(() => setIsLoading(false));
    }
  };

  const handlePublish = async (id?: string) => {
    if (auth_token && id) {
      setIsLoading(true);

      await dispatch(
        requestDBEntryApproval({ auth_token: auth_token, id: id })
      ).finally(() => setIsComplete(true));

      dispatch(
        getOwnDBEntries({
          auth_token: auth_token,
          id: linked_pages?.database_entry,
        })
      ).finally(() => setIsLoading(false));
    }
  };

  const tutorial = (
    <SettingsTutorial
      img_src={ImagePortfolio}
      title="プロフィールとは？"
      explanation="自身のスキルや実績をSELeCTに掲載できます。自身の情報を拡散するツールとしても便利です。情報を充実させて、仕事のチャンスを増やしましょう。"
    />
  );

  useEffect(() => {
    if (linked_pages?.database_entry && auth_token) {
      setIsLoading(true);
      const promise = dispatch(
        getOwnDBEntries({
          auth_token: auth_token,
          id: linked_pages?.database_entry,
        })
      );
      promise.finally(() => setIsLoading(false));

      return () => {
        promise.abort();
      };
    }
  }, [linked_pages]);

  if (isComplete === true) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        backBarText="プロフィール公開申請"
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (isLoading === true) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <Settings
        type="プロフィール"
        description="プロフィールを作成して会員からオファーを受ける準備をしましょう。プロフィールは複数作成することが可能なので、チームメンバーのプロモーションにも使用できます。"
        link="/mypage/settings/create"
        tutorial={tutorial}
        currentMenu={currentMenu}
      >
        {dbEntries.length > 0
          ? dbEntries.map((el, i) => (
              <SettingsItem
                key={i}
                page_type={"プロフィール"}
                id={el.id}
                img_src={el.imgs?.[0]?.thumbnail?.url}
                name={el.name}
                type={{
                  color: el.team?.[0]?.color,
                  name: el.player_type?.[0]?.name,
                }}
                status={el.status}
                handleMenu={() =>
                  setCurrentMenu(i === currentMenu ? undefined : i)
                }
                handlePublish={handlePublish}
                handlePrivate={handlePrivate}
                edit_link={`/mypage/settings/${el.id}`}
                detail_link={`/person/${el.id}`}
                isMenuOpen={currentMenu === i ? true : false}
                isOwner={true}
                borderColorStyle={el.team?.[0]?.color}
                verified={el.verified}
              />
            ))
          : null}
      </Settings>
    );
  }
};

export default DatabaseEntrySettingsContainer;
